import React from 'react';
import { isEmpty } from 'lodash';
import MultiDropDownAsync from '../../../DropDown/MultiDropDownAsync/MultiDropDownAsync';
import { tagStyles, BrandFilterWrapper } from './BusinessFilterSection.styles';

export const BusinessFilterSection = ({
  selectedBusinessList,
  businessNames,
  isLoading,
  hasNextPage,
  onBusinessInputChange,
  onBusinessLoad,
  onBusinessChange,
}) => {
  return (
    <MultiDropDownAsync
      label=""
      selectedIdList={selectedBusinessList}
      options={businessNames}
      onInputChange={onBusinessInputChange}
      onLoad={onBusinessLoad}
      onChange={onBusinessChange}
      nextPageExist={hasNextPage}
      isLoading={isLoading}
      styles={tagStyles}
      clearable={false}
    />
  );
};

export const BrandFilterSection = ({
  selectedBusinessIdList,
  selectedBrandOptions,
  brandOptions,
  onBrandInputChange,
  onBusinessLoad,
  onBrandChange,
  hasNextPage,
  isLoading,
}) => {
  const isBrandDisabled = isEmpty(selectedBusinessIdList);

  return (
    <BrandFilterWrapper
      $disabled={isBrandDisabled}
      title={isBrandDisabled ? 'Please select a partner first to filter by brand' : ''}
    >
      <MultiDropDownAsync
        label=""
        selectedIdList={selectedBrandOptions}
        options={brandOptions}
        onInputChange={onBrandInputChange}
        onLoad={onBusinessLoad}
        onChange={onBrandChange}
        nextPageExist={hasNextPage}
        isLoading={isLoading}
        disabled={isBrandDisabled}
        styles={tagStyles}
        clearable={false}
      />
    </BrandFilterWrapper>
  );
};
